import type theme from '#build/ui/radio-group'
import type { DeepPartial } from '@nuxt/ui'

const radioGroup: DeepPartial<typeof theme> = {
  slots: {
    root: 'relative',
    fieldset: 'flex',
    legend: 'mb-4 font-bold text-cvt-text-black',
    item: 'flex items-start',
    base: 'rounded-full shadow-none shadow-cvt-purple-800/40 ring-1 focus-visible:outline-1 focus-visible:outline-offset-2 transitions-normal hover:shadow-card',
    indicator: 'relative flex size-full items-center justify-center rounded-full after:absolute after:inset-1.5 after:z-0 after:size-full after:rounded-full transitions-normal',
    container: 'flex items-center',
    wrapper: 'ms-2',
    label: 'block font-medium text-cvt-text-black',
    description: 'text-cvt-cloud-700',
  },
  variants: {
    color: {
      neutral: {
        base: 'bg-cvt-cloud-200 hover:bg-cvt-purple-200 focus-visible:outline-cvt-cloud-800 ring-cvt-cloud-800',
        indicator: 'bg-gradient-to-t from-[#AC005F] to-[#9F1193] after:bg-cvt-cloud-200',
        legend: 'text-cvt-text-black',
      },
      error: {
        base: 'bg-cvt-cloud-200 ring-cvt-burgundy-600 hover:bg-cvt-burgundy-200 focus-visible:outline-cvt-burgundy-600',
        indicator: 'bg-radial from-cvt-cloud-200 via-cvt-cloud-200 via-60% to-100% to-cvt-cloud-800 after:bg-cvt-burgundy-600',
        legend: 'text-cvt-burgundy-600',
      },
    },
    orientation: {
      horizontal: {
        fieldset: 'flex-row',
        wrapper: 'me-2',
      },
      vertical: {
        fieldset: 'flex-col',
      },
    },
    size: {
      xs: {
        fieldset: 'gap-0.5',
        legend: 'text-xs',
        base: 'size-3',
        item: 'text-xs',
        container: 'h-4',
      },
      sm: {
        fieldset: 'gap-0.5',
        legend: 'text-xs',
        base: 'size-3.5',
        item: 'text-xs',
        container: 'h-4',
      },
      md: {
        fieldset: 'gap-1',
        legend: 'text-sm',
        base: 'size-4',
        item: 'text-sm',
        container: 'h-5',
      },
      lg: {
        fieldset: 'gap-1',
        legend: 'text-sm',
        base: 'size-4.5',
        item: 'text-sm',
        container: 'h-5',
      },
      xl: {
        fieldset: 'gap-4',
        legend: 'text-base',
        base: 'size-5',
        item: 'text-base',
        container: 'h-6',
        description: 'text-sm',
        indicator: 'after:size-2',
      },
    },
    disabled: {
      true: {
        base: 'cursor-not-allowed bg-cvt-cloud-500 hover:bg-cvt-cloud-500',
        label: 'cursor-not-allowed text-cvt-cloud-800',
      },
      false: {
        base: 'hover:shadow-card',
      },
    },
    required: {
      true: {
        legend: `after:ms-0.5 after:text-cvt-burgundy-600 after:content-['*']`,
      },
    },
  },
  defaultVariants: {
    size: 'xl',
    color: 'neutral',
  },
}

export default radioGroup
